import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Facebook Notifications: one real notification for the page among skeleton
 * rows. The ad is the sentence naming the page and quoting the headline.
 */
@Component({
  selector: 'app-meta-facebook-notifications',
  imports: [CommonModule],
  templateUrl: './facebook-notifications.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facebook-notifications.component.scss'
})
export class MetaFacebookNotificationsPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Top of each skeleton row, in px; the first two sit in the unread (blue) block. */
  readonly skeletonRows = [84, 147, 300, 363, 453];

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }
}
